import { render, staticRenderFns } from "./OutpatientCareDetail.vue?vue&type=template&id=579a818f&scoped=true&"
import script from "./OutpatientCareDetail.vue?vue&type=script&lang=js&"
export * from "./OutpatientCareDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a818f",
  null
  
)

export default component.exports